<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Clients"
            text="A table of Clients"
          >
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-btn
                      :color="color"
                      dark
                      class="mb-2"
                      v-on="on">
                      New Client
                    </v-btn>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <h4>Affiliate Information</h4>

                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-select
                          :rules="[rules.required]"
                          v-model="editedItem.affiliate_id"
                          :items="AffiliateList"
                          item-text="user.name"
                          item-value="id"
                          label="Affiliate"
                          dense
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.commission_rate"
                          label="Commission(%)" />
                      </v-flex>
                    </v-layout>

                    <h4>Business Information</h4>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.name"
                          label="Business Name" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.contact_name"
                          label="Contact Name" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required, rules.email]"
                          v-model="editedItem.email"
                          label="Email" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.phone"
                          label="Phone" />
                      </v-flex>

                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.address"
                          label="Business Address" />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-menu
                          v-model="startCalendar"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.contract_start"
                              v-bind="attrs"
                              label="Contract Start"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="editedItem.contract_start"
                            @input="startCalendar = false"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-menu
                          v-model="endCalendar"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.contract_end"
                              v-bind="attrs"
                              label="Contract End"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="editedItem.contract_end"
                            @input="endCalendar = false"
                          />
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <div>
                      <h4>Payment Method</h4>

                      <div v-if="!editedItem.has_payment || addNewPayment" >
                        <p>Add a payment method</p>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm6
                            md6>
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="newPayment.routing_number"
                              label="Routing Number" />
                          </v-flex>
                          <v-flex
                            xs12
                            sm6
                            md6>
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="newPayment.account_number"
                              label="Account Number" />
                          </v-flex>
                        </v-layout>

                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm6
                            md6>
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="newPayment.account_holder_name"
                              label="Account Holder Name" />
                          </v-flex>
                          <v-flex
                            xs12
                            sm6
                            md6>
                            <v-select
                              :rules="[rules.required]"
                              v-model="newPayment.account_holder_type"
                              :items="['individual','company']"
                              label="Account Holder Type"
                              dense
                            />
                          </v-flex>
                        </v-layout>

                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm12
                            md12>
                            <v-select
                              :rules="[rules.required]"
                              v-model="newPayment.authorization_method_id"
                              :items="authorizationMethods"
                              item-text="name"
                              item-value="id"
                              label="Authorized By"
                              dense
                            />
                          </v-flex>
                        </v-layout>
                      </div>
                      <div v-else>
                        <p style="color:lightgreen">There's connected payment method for this client! </p>

                        <div v-if="showPaymentDetail || editedItem.payment">

                          <v-layout wrap>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-text-field
                                v-model="editedItem.payment.routing_number"
                                disabled
                                label="Routing Number" />
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              md6>

                              <v-text-field
                                v-model="editedItem.payment.last4"
                                disabled
                                prefix="********"
                                label="Account Number" />
                            </v-flex>
                          </v-layout>

                          <v-layout wrap>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-text-field
                                v-model="editedItem.payment.account_holder_name"
                                label="Account Holder Name" />
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              md6>
                              <v-select
                                v-model="editedItem.payment.account_holder_type"
                                :items="['individual','company']"
                                label="Account Holder Type"
                              />
                            </v-flex>
                          </v-layout>

                          <v-layout wrap>
                            <v-flex
                              xs12
                              sm12
                              md12>
                              <v-text-field
                                v-model="editedItem.authorization_method.name"
                                disabled
                                label="Authorized By"
                              />
                            </v-flex>
                          </v-layout>

                          <v-btn
                            v-if="editedItem.has_payment"
                            color="red darken-1"
                            @click="addNewPayment = true">
                            Replace
                          </v-btn>

                          <v-btn
                            v-if="editedItem.has_payment"
                            color="blue darken-1"
                            class="right"
                            @click="updatePayment">
                            Update
                          </v-btn>
                        </div>
                        <v-btn
                          v-else
                          color="blue darken-1"
                          @click="getPayment">
                          Get Payment Details
                        </v-btn>
                      </div>
                      <!--<PlaidLink :client_id="editedItem.id" :key="editedItem.id"> </PlaidLink>-->
                    </div>

                  </v-container>

                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-checkbox
                    v-model="editedItem.active"
                    class="float-right"
                    label="Active"/>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="close">Cancel</v-btn>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="ClientList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">
                  <td>
                    <v-icon
                      v-if="!props.item.has_payment"
                      small
                      color="red"
                      @click="showWarningMessage('There is no payment information for this client')">warning</v-icon>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.contract_start }}
                  </td>
                  <td>{{ props.item.contract_end }}</td>
                  <!--<td>-->
                  <!--<v-select-->
                  <!--v-model="props.item.affiliate_id"-->
                  <!--:items="AffiliateList"-->
                  <!--style="border-style:none"-->
                  <!--disabled-->
                  <!--item-text="user.name"-->
                  <!--item-value="id"-->
                  <!--/>-->
                  <!--</td>-->
                  <td>{{ new Date(props.item.created_at).toLocaleString() }}</td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                  <td class="justify-center ">

                    <v-icon
                      class="mr-2"
                      small
                      @click="editItem(props.item)">edit</v-icon>
                    <v-icon
                      small
                      @click="deleteItem(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="8000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PlaidLink from '../core/PlaidLink'

  export default {
    components: {PlaidLink},
    data: () => ({
      token_link: '',
      handler: null,
    snack: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max25chars: v => v.length <= 25 || 'Input too long!',
      // counter: value => value.length <= 20 || 'Max 20 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    },
    pagination: {},
    ClientList: [

    ],
    AffiliateList: [

    ],
      authorizationMethods: [

      ],
      showPaymentDetail: false,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Business',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Start',
        align: 'left',
        value: 'contract_start'
      },
      {
        text: 'End',
        align: 'left',
        value: 'contract_end'
      },
      // {
      //   text: 'Affiliate',
      //   align: 'left',
      //   value: 'affiliate_id'
      // },
      {
        text: 'Created At',
        align: 'left',
        value: 'created_at'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }

    ],
    editedIndex: -1,
      addNewPayment: false,
    editedItem: {
      id: '',
      affiliate_id: '',
      number: 'AUTO ASSIGN',
      address: '',
      phone: '',
      contract_start: '',
      contract_end: null,
      created_at: '',
      active: true,
      contact_name: '',
      email: '',
      commission_rate: ''
    },
    defaultItem: {
      id: '',
      affiliate_id: '',
      number: 'AUTO ASSIGN',
      address: '',
      phone: '',
      contract_start: '',
      contract_end: null,
      created_at: '',
      active: true,
      contact_name: '',
      email: '',
      commission_rate: ''
    },
      newPayment: {
        account_holder_name: '',
        account_holder_type: '',
        routing_number: '',
        account_number: '',
        authorization_method_id: ''
      },
      defaultPayment: {
        account_holder_name: '',
        account_holder_type: '',
        routing_number: '',
        account_number: '',
        authorization_method_id: ''
      }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Client' : 'Edit Client'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.affiliate_id': function (newValue, oldValue) {
      if (this.editedItem.id === '') {
        for (var i = 0; i < this.AffiliateList.length; i++) {
          if (this.AffiliateList[i].id == newValue) {
            this.editedItem.commission_rate = this.AffiliateList[i].commission_rate
            break
          }
        }
      }
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
    this.getAuthorizationMethods()
  },

  methods: {
      addPayment (id) {
        this.$store.state.spinning = true
        axios.post('/api/admin/clients/' + id + '/payment', this.newPayment)
                .then((response) => {
                    if (this.editedItem.id) {
                        Object.assign(this.ClientList[this.editedIndex], response.data)
                    } else {
                        this.ClientList.unshift(response.data)
                    }
                  this.close()
                  this.snack = true
                  this.snackColor = 'success'
                  this.snackText = 'Payment Information added successfully!'
                  this.$store.state.spinning = false
                })
                .catch(error => {
                  console.log(error.message)
                  console.log(error.response)
                  this.snack = true
                  this.snackColor = 'error'
                    let message = 'Client created successfully, but failed to add payment information!'
                  if (error.response && error.response.data) {
                      message = error.response.data
                  }
                  this.snackText = message
                  this.$store.state.spinning = false
                })
      },
    getPayment () {
      axios.get('/api/admin/clients/' + this.editedItem.id + '/payment')
              .then(response => {
                console.log(response.data)
                this.editedItem = response.data
                Object.assign(this.ClientList[this.editedIndex], response.data)
                this.showPaymentDetail = true
              })
              .catch(err => {
                console.log(err.message)
              })
    },
    updatePayment () {
      this.$store.state.spinning = true
      axios.put('/api/admin/clients/' + this.editedItem.id + '/payment', {
        'account_holder_name': this.editedItem.payment.account_holder_name,
        'account_holder_type': this.editedItem.payment.account_holder_type
      })
              .then(response => {
                console.log(response.data)
                this.editedItem = response.data
                Object.assign(this.ClientList[this.editedIndex], response.data)
                this.showPaymentDetail = true
                this.snack = true
                this.snackColor = 'success'
                this.snackText = 'Payment Information updateded successfully!'
                this.$store.state.spinning = false
              })
              .catch(error => {
                console.log(error.message)
                console.log(error.response)
                this.snack = true
                this.snackColor = 'error'
                let message = 'Failed to update payment information, please try again!'
                if (error.response && error.response.data) {
                  message = error.response.data
                }
                this.snackText = message
                this.$store.state.spinning = false
              })
    },
    index () {
      this.loading = true
      let self = this
      axios.get('/api/admin/clients')
              .then(response => {
                self.ClientList = response.data
                self.loading = false
                self.getAffiliates()
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },
    getAuthorizationMethods () {
      axios.get('/api/admin/clients/authorization_methods')
              .then(response => {
                this.authorizationMethods = response.data
              })
              .catch(err => {
                console.log(err.response.data.errors)
              })
    },
    getAffiliates () {
      let self = this
      axios.get('/api/admin/affiliates')
              .then(response => {
                self.AffiliateList = response.data
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.ClientList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.ClientList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/api/admin/clients/' + item.id)
                .then((response) => {
                  this.ClientList.splice(index, 1)
                  this.deleteInline()
                          this.close()
                          this.$store.state.spinning = false
                        }
                )
                .catch(error => {
                  if (error.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(error.response.data.errors)
                  }
                  console.log(error)
                  this.cancelInline
                  this.$store.state.spinning = false
                })
      }
    },

    close () {
      this.dialog = false
      this.showPaymentDetail = false
        this.addNewPayment = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.newPayment = Object.assign({}, this.defaultPayment)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedItem.id !== '') {
        this.$store.state.spinning = true

        axios.put('/api/admin/clients/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.ClientList[this.editedIndex], response.data)
            if (!this.editedItem.has_payment || this.addNewPayment) {
             this.addPayment(this.editedItem.id)
            } else {
              this.updateInline()
              this.$store.state.spinning = false
            }
              }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true

        axios.post('/api/admin/clients', this.editedItem)
                .then((response) => {
                  this.saveInline()
                  this.addPayment(response.data.id)
                })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Client created!'
    },
    updateInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Client updated!'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Client deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    },
      showWarningMessage (message) {
          this.snack = true
          this.snackColor = 'warning'
          this.snackText = message
      }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
